var _style, _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMhc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.5 56",
    style: {
      enableBackground: "new 0 0 150.5 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000181796741401789421610000008718510156252651174_);}\n\t.st1{fill:#004E2B;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#00DD39;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 56,
    height: 56
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000102542022297847470860000004734540927422592663_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000102542022297847470860000004734540927422592663_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,0H16.8C7.5,0,0,7.5,0,16.8v22.5C0,48.5,7.5,56,16.8,56h22.5C48.5,56,56,48.5,56,39.2V16.8 C56,7.5,48.5,0,39.2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.2,24.3h-3.4c-0.4-2-1.2-3.8-2.3-5.5l2.4-2.4c0.3-0.3,0.3-0.7,0-1l-4.2-4.2c-0.3-0.3-0.7-0.3-1,0l-2.4,2.4 c-1.6-1-3.5-1.9-5.5-2.3V7.9c0-0.4-0.3-0.7-0.7-0.7h-6c-0.4,0-0.7,0.3-0.7,0.7v3.4c-2,0.4-3.8,1.2-5.5,2.3l-2.4-2.4 c-0.3-0.3-0.7-0.3-1,0l-4.2,4.2c-0.3,0.3-0.3,0.7,0,1l2.4,2.4c-1,1.6-1.9,3.5-2.3,5.5H7.8c-0.4,0-0.7,0.3-0.7,0.7V31 c0,0.4,0.3,0.7,0.7,0.7h3.4c0.4,2,1.2,3.8,2.3,5.5l-2.4,2.4c-0.3,0.3-0.3,0.7,0,1l4.2,4.2c0.3,0.3,0.7,0.3,1,0l2.4-2.4 c1.6,1,3.5,1.9,5.5,2.3v3.4c0,0.4,0.3,0.7,0.7,0.7h6c0.4,0,0.7-0.3,0.7-0.7v-3.4c2-0.4,3.8-1.2,5.5-2.3l2.4,2.4 c0.3,0.3,0.7,0.3,1,0l4.2-4.2c0.3-0.3,0.3-0.7,0-1l-2.4-2.4c1-1.6,1.9-3.5,2.3-5.5h3.4c0.4,0,0.7-0.3,0.7-0.7V25 C48.9,24.6,48.6,24.3,48.2,24.3z M28,39.2c-6.1,0-11.2-5-11.2-11.2s5-11.2,11.2-11.2s11.2,5,11.2,11.2S34.2,39.2,28,39.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M28,33.6c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6S24.9,33.6,28,33.6z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.7,28.2l7.4-10.6h4.7V40h-5.3v-7.1c0-2.5,0.1-4.7,0.3-6.8l-6.1,8.4h-2.1l-6-8.3c0.2,2,0.3,4.1,0.3,6.7V40 h-5.3V17.6h4.9L85.7,28.2z M118.5,26.4v-8.8h5.4V40h-5.4v-8.7h-10.2V40h-5.4V17.6h5.4v8.8H118.5z M140,40.3 c-7.2,0-12.5-4.7-12.5-11.6c0-6.7,5.5-11.6,12.6-11.6c3.6,0,7.1,1.4,9.2,3.6l-3.2,4c-1.5-1.4-3.5-2.5-6.1-2.5 c-3.6,0-6.9,2.5-6.9,6.6s3.3,6.6,7.4,6.6c2.7,0,4.7-1.3,6.1-2.5l2.6,4.2C147.5,38.7,143.8,40.3,140,40.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMhc);
export default __webpack_public_path__ + "static/media/LogoMHC.8eca698373919c800a1570c6620b0e25.svg";
export { ForwardRef as ReactComponent };